module.exports = __webpack_public_path__ + "static/media/wilson.92af7e0a.jpg";